@if (!hasApprovedVehicle()) {
  <onyx-divider variant="modal" edge="top"></onyx-divider>
}

<section>
  @if (draftState(); as draftState) {
    <div class="draft">
      <onyx-message intent="neutral">
        <onyx-icon name="tooltip-filled" [size]="20"></onyx-icon>

        <p>{{ draftState.heading | translate }}</p>

        <span description>{{ draftState.description | translate }}</span>
      </onyx-message>

      <onyx-button
        [spinner]="loading()"
        (click)="!loading() ? draftState.button.action() : null"
      >
        {{ draftState.button.text | translate }}
      </onyx-button>
    </div>
  } @else if (!hasApprovedVehicle()) {
    <div class="vehicle-choice">
      <div class="tab-container">
        <onyx-information-heading align="center">
          {{ `${I18N}.vehicleChoice` | translate }}

          @if (order().timestamps.toAcceptAt || order().timestamps.toDoAt) {
            <onyx-icon-button
              actions
              color="gray"
              variant="transparent"
              [size]="32"
              icon="history-outlined"
              [circle]="true"
              onyxTooltip="labels.vehicleAndDriverHistory"
              (click)="openActivityModal()"
            ></onyx-icon-button>
          }

          <app-order-modal-deadline-message
            subheading
            [order]="order()"
          ></app-order-modal-deadline-message>
        </onyx-information-heading>

        <onyx-tabs
          [tabs]="tabs()"
          [(value)]="tab"
          [fill]="true"
          [size]="40"
          width="100%"
        ></onyx-tabs>
      </div>

      @switch (tab()) {
        @case (OrderPlanningMode.AUTO) {
          @if (!hasEngineProposal()) {
            @if (
              startPlanningData()?.isWaiting && startPlanningData()?.deadline;
              as deadline
            ) {
              <div class="waiting">
                <onyx-icon
                  class="f-muted"
                  name="clock-filled"
                  [size]="24"
                ></onyx-icon>

                <div class="waiting-content">
                  <p class="f-body-l f-medium">
                    {{ 'labels.waitingTo' | translate }}
                    {{ deadline | onyxDate: 'time-date-dot' }}
                  </p>

                  <p class="f-body-s f-muted">
                    {{
                      `${I18N}.autoPlanningStartsSevenDaysBefore` | translate
                    }}
                  </p>
                </div>
              </div>
            } @else if (!missingAssignment()) {
              <onyx-empty-state
                orientation="horizontal"
                heading="orders.ordersList.cells.searchingVehicle"
                description="orders.orderModal.engineChoosesBestVehicle"
                [pulse]="true"
              >
                <onyx-logo variant="signet" theme="light"></onyx-logo>
              </onyx-empty-state>
            }
          }
        }

        @case (OrderPlanningMode.MANUAL) {
          <div class="manual-buttons">
            <onyx-dropdown
              [value]="selectedManualVehicleUuid()"
              [options]="vehiclesSource()"
              [disabled]="
                isManualProposalLoading() ||
                loading() ||
                !!manualProposal()?.result
              "
              (selectedOptionValueChange)="
                selectedManualVehicle.set($event.value)
              "
            ></onyx-dropdown>

            <onyx-button
              variant="outlined"
              [spinner]="loading()"
              [disabled]="!manualProposal()"
              (click)="
                manualProposal() && !loading() ? deleteManualProposal() : null
              "
            >
              {{ 'labels.cancel' | translate }}
            </onyx-button>

            @let isSubmitDisabled =
              isManualProposalLoading() ||
              !selectedManualVehicle() ||
              hasTrailerConflict() ||
              loading();
            <onyx-button
              color="violet"
              [spinner]="loading()"
              [disabled]="isSubmitDisabled"
              (click)="
                !isSubmitDisabled
                  ? manualProposal()
                    ? confirmManualProposal()
                    : addManualProposal()
                  : null
              "
            >
              {{
                `labels.${manualProposal() ? 'confirm' : 'calculate'}`
                  | translate
              }}
            </onyx-button>
          </div>

          @if (hasTrailerConflict()) {
            <onyx-message intent="warning">
              <onyx-icon
                name="alert-circle-two-tone-filled"
                [size]="20"
              ></onyx-icon>

              <p
                [innerHTML]="
                  `${I18N}.assignedTrailerWarning`
                    | translate
                      : {
                          vehicle:
                            selectedManualVehicle()?.generalInformation
                              ?.registrationNumber,
                        }
                "
              ></p>

              <p description>
                {{ `${I18N}.assignedTrailerWarningDescription` | translate }}
              </p>

              <onyx-button
                buttons
                variant="ghost"
                [size]="32"
                [spinner]="loading()"
                (click)="unassignTrailer()"
              >
                {{ 'labels.unpin' | translate }}
              </onyx-button>
            </onyx-message>
          }

          @if (isManualProposalLoading()) {
            <div class="calculating">
              <onyx-empty-state
                orientation="horizontal"
                [heading]="`${I18N}.engineCalculating`"
                [description]="`${I18N}.upToMinute`"
                [pulse]="true"
              >
                <onyx-logo variant="signet" theme="light"></onyx-logo>
              </onyx-empty-state>

              <onyx-button
                variant="outlined"
                [spinner]="forceLoading()"
                (click)="!forceLoading() && forceManualProposal()"
              >
                {{ `${I18N}.forceAssignment` | translate }}
              </onyx-button>
            </div>
          }
        }

        @case (OrderPlanningMode.OUTSOURCING) {
          <app-order-modal-outsourcing-form
            [order]="order()"
            [mode]="OnyxFormMode.ADD"
            [close$]="close$()"
          ></app-order-modal-outsourcing-form>
        }
      }
    </div>
  }

  @if (!draftState()) {
    <app-order-modal-assignment
      [order]="order()"
      [selectedManualVehicle]="selectedManualVehicle()"
      [(tab)]="tab"
      [close$]="close$()"
    ></app-order-modal-assignment>
  }
</section>

@if (!hasApprovedVehicle()) {
  <onyx-divider variant="modal" edge="bottom"></onyx-divider>
}
